<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { UiTone, UiSize } from '~/utils/ui'
const props = withDefaults(
  defineProps<{
    to?: RouteLocationRaw
    href?: string
    external?: boolean
    target?: string
    variant?: 'default' | 'subtle' | 'solid' | 'soft' | 'outline' | 'ghost'
    tone?: UiTone
    size?: UiSize
    rel?: string
    disabled?: boolean
  }>(),
  {
    to: undefined,
    href: undefined,
    external: undefined,
    target: undefined,
    rel: undefined,
    disabled: undefined,
    variant: 'default',
    tone: 'accent',
    size: 'md',
  },
)
const classes = computed(() =>
  ['default', 'subtle'].includes(props.variant)
    ? ['ui-link', `ui-link--${props.variant}`]
    : [
        'ui-link',
        'ui-button',
        `ui-button--${props.variant}`,
        `ui-tone--${props.tone}`,
        `ui-size--${props.size}`,
      ],
)
const safeRel = computed(() =>
  props.target === '_blank' ? `${props.rel ?? ''} noopener noreferrer`.trim() : props.rel,
)
</script>
<template>
  <span
    v-if="disabled"
    :class="classes"
    aria-disabled="true"
    ><slot name="leading" /><slot /><slot name="trailing"
  /></span>
  <NuxtLink
    v-else-if="to"
    :to="to"
    :external="external"
    :target="target"
    :rel="safeRel"
    :class="classes"
    ><slot name="leading" /><slot /><slot name="trailing"
  /></NuxtLink>
  <a
    v-else
    :href="href"
    :target="target"
    :rel="safeRel"
    :class="classes"
    ><slot name="leading" /><slot /><slot name="trailing"
  /></a>
</template>
